module.exports = __webpack_public_path__ + "img/home-delivery-date-top-img.cfa24a2d.webp";